import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateUsuarioRequest extends CreateKeyValueRequest {

    public userName! : string;
    public password! : string;
    public nombre! : string;
    public apellido! : string;
    public correo!:string;
    public telefono!:string;
    public codigoPostal!:string;
    public direccion!:string;
    public activo! : boolean;
    public changePassword! : boolean;
    public idRol! : number;

}
